import React, { useEffect } from "react";

import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  useMap,
} from "react-leaflet";

import L from "leaflet";

import styles from "./HotelMapview.module.css";


// ==========================================
// CUSTOM HOTEL MARKER
// ==========================================

const hotelIcon = L.divIcon({
  className: styles.hotelMarker,

  html: `
    <div class="${styles.markerPin}">
      <span class="${styles.markerDot}"></span>
    </div>
  `,

  iconSize: [30, 42],
  iconAnchor: [15, 42],
  popupAnchor: [0, -42],
});


// ==========================================
// MAP FIT COMPONENT
// ==========================================

const MapBounds = ({ hotels }) => {

  const map = useMap();


  useEffect(() => {

    if (!hotels || hotels.length === 0) {
      return;
    }


    const validHotels = hotels.filter(
      (hotel) =>
        hotel.latitude !== null &&
        hotel.latitude !== undefined &&
        hotel.longitude !== null &&
        hotel.longitude !== undefined
    );


    if (validHotels.length === 0) {
      return;
    }


    // ==========================================
    // SINGLE HOTEL
    // ==========================================

    if (validHotels.length === 1) {

      const hotel = validHotels[0];

      map.setView(
        [
          Number(hotel.latitude),
          Number(hotel.longitude),
        ],
        15,
        {
          animate: true,
        }
      );

      return;
    }


    // ==========================================
    // MULTIPLE HOTELS
    // ==========================================

    const bounds = L.latLngBounds(
      validHotels.map((hotel) => [
        Number(hotel.latitude),
        Number(hotel.longitude),
      ])
    );


    map.fitBounds(bounds, {
      padding: [50, 50],
      maxZoom: 14,
      animate: true,
    });

  }, [hotels, map]);


  return null;
};


// ==========================================
// HOTEL MAP
// ==========================================

const HotelMap = ({ hotels = [] }) => {

  const validHotels = hotels.filter(
    (hotel) =>
      hotel.latitude !== null &&
      hotel.latitude !== undefined &&
      hotel.longitude !== null &&
      hotel.longitude !== undefined
  );


  // ==========================================
  // NO LOCATION DATA
  // ==========================================

  if (validHotels.length === 0) {

    return (
      <div className={styles.emptyMap}>
        <p>
          Location information is not available
          for these hotels.
        </p>
      </div>
    );

  }

  const createHotelIcon = (hotelName) => {
  return L.divIcon({
    className: styles.hotelMarker,

    html: `
      <div class="${styles.markerContainer}">
        
        <div class="${styles.markerPin}">
          <span class="${styles.markerDot}"></span>
        </div>

        <div class="${styles.hotelLabel}">
          ${hotelName || "Hotel"}
        </div>

      </div>
    `,

    iconSize: [180, 58],
    iconAnchor: [90, 58],
    popupAnchor: [0, -58],
  });
};


  return (

    <div className={styles.mapWrapper}>

      <MapContainer
        center={[
          Number(validHotels[0].latitude),
          Number(validHotels[0].longitude),
        ]}
        zoom={12}
        scrollWheelZoom={true}
        className={styles.map}
      >

        {/* ==========================================
            MAP TILES
        ========================================== */}

        <TileLayer
          attribution="&copy; OpenStreetMap contributors"
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />


        {/* ==========================================
            AUTOMATIC FIT
        ========================================== */}

        <MapBounds
          hotels={validHotels}
        />


        {/* ==========================================
            HOTEL MARKERS
        ========================================== */}

        {validHotels.map((hotel) => (
<Marker
  key={
    hotel.id ||
    hotel.slug ||
    hotel.name
  }
  position={[
    Number(hotel.latitude),
    Number(hotel.longitude),
  ]}
  icon={createHotelIcon(hotel.name)}
>

            <Popup>

              <div className={styles.popup}>

                <h3>
                  {hotel.name}
                </h3>


                {(hotel.city ||
                  hotel.state) && (

                  <p className={styles.location}>
                    {[
                      hotel.city,
                      hotel.state,
                    ]
                      .filter(Boolean)
                      .join(", ")}
                  </p>

                )}


                {hotel.star_rating && (

                  <div className={styles.rating}>
                    ★ {hotel.star_rating}
                  </div>

                )}


                {hotel.address && (

                  <p className={styles.address}>
                    {hotel.address}
                  </p>

                )}


                {hotel.google_map_url && (

                  <a
                    href={
                      hotel.google_map_url
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.mapLink}
                  >
                    Open in Google Maps
                  </a>

                )}

              </div>

            </Popup>

          </Marker>

        ))}

      </MapContainer>


      {/* ==========================================
          MAP LEGEND
      ========================================== */}

      <div className={styles.mapLegend}>

        <span className={styles.legendPin}></span>

        <span>
          Event Hotels
        </span>

      </div>

    </div>

  );
};


export default HotelMap;